(function ($) {
    let hostHeaderData = null;
    let okCallback = null;
    let cancelCallback = null;

    const doEnableButtons = function (invokerID) {
    	if ($('#hostHeader').val().length > 0) {
    		$('.ok-button').removeAttr('disabled');
		} else {
		    $('.ok-button').attr('disabled', 'disabled');
		}
    };

    const enableButtons = function () {
        doEnableButtons($(this).attr('id'));
    };

    $.extend({
        showHostHeaderDialog: function(options) {
        	const buttonID = '#hostHeaderAddButton';

            if (!!options) {
                okCallback = options.okCallback;
                cancelCallback = options.cancelCallback
            }

            $('#hostHeaderDialog').dialog({
                modal: true,
                width: 425,
                draggable: false,
                resizable: false,
                classes: {'ui-dialog' : 'cpwr-ui-dialog tokens-dialog'},
                buttons: {
                    "OK": {
                        text: okText,
                        "class": 'ok-button',
                        click: function () {
                            if (typeof okCallback === 'function') {
                                okCallback.call(this);
                            }
                            $.animateCloseDialog('#hostHeaderDialog', buttonID);
                            $(this).dialog('close');
                        }
                    },
                    "Cancel": {
                        text: cancelText,
                        "class": 'cancel-button',
                        click: function () {
                            $.animateCloseDialog('#hostHeaderDialog', buttonID);
                            $(this).dialog('close');
                            if(!!cancelCallback) {
                            	cancelCallback.call(this);
                            }
                        }
                    }
                },
                open: function () {
                    var okButton = $('.ok-button');
                    okButton.html(okText);
                    okButton.attr('disabled', 'disabled');

                    $.animateOpenDialog('#hostHeaderDialog', buttonID, true, null, function () {
                        $('#hostHeader').focus();
                    });
                },
                close: function () {
                    $('#hostHeader').val('');	
	                $('.ok-button').removeAttr('disabled');
	            }
	        });
        }
    });

    $('#hostHeader').on('input focusin focusout change', enableButtons);
})(jQuery);